import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'la-auth-card',
  imports: [],
  templateUrl: './auth-card.component.html',
  styleUrl: './auth-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthCardComponent {
  @Input() title = '';
}
